import { getMidwayToken, MidwayUser } from './midway';
import { jwtDecode } from 'jwt-decode';

export interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: MidwayUser | null;
  error: string | null;
}

interface JWTPayload {
  sub: string;
  name?: string;
  given_name?: string;
  family_name?: string;
  email?: string;
  [key: string]: unknown;
}

// Skip auth in local development
const isLocalDev = typeof window !== 'undefined' && window.location.hostname === 'localhost';

let authToken: string | null = null;

export function getAuthToken(): string | null {
  return authToken;
}

export async function initializeAuth(): Promise<AuthState> {
  // Use mock user for local development
  if (isLocalDev) {
    return {
      isAuthenticated: true,
      isLoading: false,
      user: {
        user_id: 'local-dev',
        given_name: 'Local',
        family_name: 'Developer',
        email: 'local@amazon.com',
      },
      error: null,
    };
  }

  try {
    // getMidwayToken handles extracting token from URL or fetching/redirecting
    authToken = await getMidwayToken();
    const decoded = jwtDecode<JWTPayload>(authToken);

    return {
      isAuthenticated: true,
      isLoading: false,
      user: {
        user_id: decoded.sub,
        name: decoded.name,
        given_name: decoded.given_name,
        family_name: decoded.family_name,
        email: decoded.email,
      },
      error: null,
    };
  } catch (error) {
    // getMidwayToken will redirect if needed, so if we get here it's a real error
    return {
      isAuthenticated: false,
      isLoading: false,
      user: null,
      error: error instanceof Error ? error.message : 'Authentication failed',
    };
  }
}
